import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69c2f358"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dd-header__title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dd-header__icon" }, null, -1))
const _hoisted_3 = {
  key: 0,
  class: "companies-drop-down__list-wrapper list-wrapper"
}
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["companies-drop-down", {
      'companies-drop-down--is-opened': _ctx.isOpened,
    }])
  }, [
    _createElementVNode("div", {
      class: "companies-drop-down__dd-header dd-header",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.selectedCompany)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.selectedCompany.name), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Бренды и рестораны союза ")
            ], 64))
      ]),
      _hoisted_2
    ]),
    (_ctx.isOpened)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parentCompany.children, (company) => {
              return (_openBlock(), _createElementBlock("a", {
                key: company.id,
                href: _ctx.domainWithProtocol(company.domain?.name),
                class: "list__item",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggle(false)))
              }, [
                _createElementVNode("img", {
                  src: "",
                  alt: company.login
                }, null, 8, _hoisted_6)
              ], 8, _hoisted_5))
            }), 128)),
            _createElementVNode("a", {
              href: _ctx.domainWithProtocol(_ctx.company.domain?.name),
              class: "list__item list__item--to-all",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(false)))
            }, " Все бренды ", 8, _hoisted_7)
          ])
        ])), [
          [_directive_click_outside, () => _ctx.toggle()]
        ])
      : _createCommentVNode("", true)
  ], 2))
}